import React from "react";
import { BigSpringLogo, StyledLogoText } from "./styles";
import { Grid } from "../Grid";

export function Logo() {
  return (
    <Grid container p={1}>
      <Grid item>
        <BigSpringLogo />
      </Grid>
      <Grid item ml={1}>
        <StyledLogoText>BigSpring</StyledLogoText>
      </Grid>
    </Grid>
  );
}
